import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import TermSheetScheduleRowDeleteModalUI from './TermSheetScheduleRowDeleteModalUI.js'

class TermSheetScheduleRowDeleteModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
    }
  }

  render() {
    return (
      <TermSheetScheduleRowDeleteModalUI
        context={this.props.context}
        deleteMode={this.props.deleteMode}
        submitted={this.state.submitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onDeleteRowCancel}
        particular={this.props.row && this.props.row.particular}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    if (this.state.submitted || !this.props.row) return
    this.setState({ successMsg: null, errorList: [], submitted: true })
    RestApiUtils.delete(
      this.props.context,
      this.props.loan.loanId === 'master'
        ? `/api/su/master/termSheet/scheduleRows/${this.props.row.templateId}`
        : `/api/su/loans/${this.props.loan.loanId}/termSheet/scheduleRows/${this.props.row.templateId}`,
      this.onSubmitCallback
    )
  }

  onSubmitCallback = (response) => {
    this.setState({
      successMsg: response.success,
      errorList: response.errorList,
      submitted: false,
    })
    if (!response.errorList || response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.props.onDeleteRowCancel()
        this.props.onRefreshClick('noBusy')
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default TermSheetScheduleRowDeleteModalSF
